import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("/outcomes/sources");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllByOutcomesID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("/outcomes/sources/byOutcomesID", { params: { id: id } });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {}

      await api.post(`outcomes/sources`, payload).then(response => {
        if (response.data.Result == "Success") {
          returnData = {
            Result: "Success",
            Response: response.data
          };
        } else {
          returnData = {
            Result: "Failed",
            Response: response.data
          };
        }
      }).catch(err => {
        returnData = {
          Result: "Error",
          Response: {
            Message: "There was an Error, Please try again later"
          }
        };
      })
      dispatch("loadAllByOutcomesID", payload.outcomes_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`outcomes/sources`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAllByOutcomesID", payload.outcomes_id);
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
  }
}
